<template>
   <v-container>
      <v-row>
        <v-col cols="12">
          <div class="title-container">
            <h1 class="mr-5">Showcase Page</h1>
            <div>
              <v-layout justify-center>
                <v-row justify="center" class="mock-page-container">
                  <v-col cols="12">
                    <v-btn block @click="toMockPage" depressed rounded class="gambling-btn white--text">
                      Cashier Demo Page
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-layout>
            </div>
          </div>
          <p>
            Showcase the cashier, it rocks!
          </p>
        </v-col>
        <v-col cols="12">
          <p class="subheading theme-main-color text--darken-2">Presets to showcase:</p>
          <NewComboboxShowcase />
        </v-col>
        <v-col cols="12">
          <v-row style="padding:12px;">
            <v-checkbox
              v-model="cashierFillHeight"
              label="Use full height"
            ></v-checkbox>
            <v-btn rounded large block class="success" @click="openModal = true">
              Start showcasing the cashier!
              <v-icon class="pl-4">mdi-emoticon-cool</v-icon>
            </v-btn>
          </v-row>
          <ShowcaseModal
            :reloadCashierCarousel="reloadCashierCarousel"
            :closeDialog="closeModal"
            :dialog="openModal" />
        </v-col>
      </v-row>
   </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ShowcaseModal from './ShowcaseCmpnts/ShowcaseModal'
import NewComboboxShowcase from './ShowcaseCmpnts/NewComboboxShowcase'

export default {
  name: 'Showcase',
  components: {
    ShowcaseModal,
    NewComboboxShowcase
  },
  data: () => ({
    msg: null,
    openModal: false,
    cashierFillHeight: false,
    reloadCashierCarousel: 0
  }),
  watch: {
    cashierFillHeight () {
      this.updateReloadCashierCarousel()
    },
    mapReloadCashierCarousel () {
      this.reloadCashierCarousel++
    }
  },
  computed: {
    ...mapState({
      mapReloadCashierCarousel: ({ config }) => config.reloadCashierCarousel
    })
  },
  methods: {
    ...mapMutations([
      'updateReloadCashierCarousel'
    ]),
    toMockPage () {
      window.open(`https://cashier-demo.paymentiq.io/`)
    },
    closeModal () {
      this.openModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  display: flex;
  justify-content: space-between;
  .mock-page-container {
    text-align: center;
    background: #ffffff;
    border-radius: 15px;
    border: 1px solid lightgrey;
  }
  .gambling-btn {
    background: #fc4a1a;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #f7b733, #fc4a1a);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #f7b733, #fc4a1a); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
}
</style>
